// eslint-disable-next-line import/prefer-default-export
export function calculateActivityBudget(unitValue, quantity) {
  if (!unitValue || !quantity) {
    return 0;
  }

  return Math.round(unitValue * quantity);
}
